import { useDebounce } from '@common/hooks';
import React from 'react';

export const DebouncedInput = ({
                                 value,
                                 placeholder,
                                 onValueChange,
                                 onDebounce,
                                 debounceTime,
                                 onFocus,
                                 onKeyDown,
                               }: DebouncedInputProps) => {
  const debouncedValue = useDebounce((search: string) => onDebounce(search), debounceTime);

  const handleInputChange = (search: string) => {
    onValueChange?.(search);
    debouncedValue(search);
  };

  return (
    <input
      className={'form-field-input min-w-[300px]'}
      placeholder={placeholder ?? ''}
      type="text"
      value={value}
      onFocus={() => onFocus?.()}
      onKeyDown={(ev) => onKeyDown?.(ev)}
      onChange={(ev) => handleInputChange(ev.target.value)}
    />
  );
};

interface DebouncedInputProps {
  /**
   * Seconds.
   * @default 0
   */
  debounceTime: number;
  value: string;
  onDebounce: (value: string) => void;
  onValueChange?: (string: string) => void;
  placeholder?: string;
  onFocus?: () => void;
  onKeyDown?: (ev) => void;
}